import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select')

class Dynamic extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			editing: false,
			deleting: false,
			loading: false,
			view: false,
			filterBy: {}, sortBy: '', sortOrder: 1
		};
	}

	edit = (item) => (e) => {
		if (!item) {
			this.setState({ editing: {} })
		} else {
			this.setState({ editing: JSON.parse(JSON.stringify(item)) })
		}
	}

	delete = (item) => (e) => {
		e.stopPropagation()
		this.setState({ deleting: item })
	}

	confirm = (e) => {
		this.setState({ loading: true });
		if (this.state.editing) {
			this.props.ws.send(JSON.stringify({ route: 'addEditItem', module: this.state.view, item: this.state.editing }))
		} else if (this.state.deleting) {
			this.props.ws.send(JSON.stringify({ route: 'deleteItem', module: this.state.view, item: this.state.deleting }))
		}
	}

	cancel = (e) => {
		this.setState({ editing: false, deleting: false, loading: false })
	}
	toggle = (field) => (e) => {
		var newState = this.state.editing
		newState[field] = newState[field] ? false : true
		this.setState({ editing: newState })
	}
	valueChange = (field, type) => (e) => {
		var newState = this.state.editing

		if (type == 'string') {
			newState[field] = e.currentTarget.value
		} else if (type == 'phone') {
			newState[field] = e.currentTarget.value.replace(/\D/gm, '').substr(0, 10)
		}

		this.setState({ editing: newState })
	}


	timeSelect = (field) => (datetime) => {

		var newState = this.state.editing

		if (datetime && Math.abs(new Date().getTime() - datetime[0].getTime()) < 1000) {
			newState[field] = '12:00'
		} else if (datetime) {
			newState[field] = datetime[0].getHours() + ':' + datetime[0].getMinutes()
		} else {
			delete newState[field]
		}

		this.setState({ editing: newState })
	}
	clearDateTime = (field) => (e) => {
		var newState = this.state.editing
		delete newState[field]
		this.setState({ editing: newState })
	}
	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirm();
		}
	}
	componentWillMount() {
		for (var module in this.props.data) {
			if (this.props.data[module] && this.props.data[module].hasOwnProperty('schema')) {
				this.setState({ view: module, sortBy: this.props.data[module].sortBy })
			}
		}
	}
	componentWillReceiveProps() {
		if (this.state.loading) {
			this.cancel()
		}
	}

	renderDynamicInput = (param) => {
		if (param instanceof Array) {
			var grouping = []
			for (subItem of param) {
				grouping.push(this.renderDynamicInput(subItem))
			}
			return (<div style={{ display: 'flex' }}>{grouping}</div>)
		} else if (param.type == 'string') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input className="textInput" type="text" required value={this.state.editing[param.name]} onChange={this.valueChange(param.name, param.type)} ></input>
					<span className="inputBar"></span><label className="textLabel">{param.name}</label>
				</div>
			)
		} else if (param.type == 'phone') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input className="textInput" type="text" required value={this.state.editing[param.name]} onChange={this.valueChange(param.name, param.type)} ></input>
					<span className="inputBar"></span><label className="textLabel">{param.name}</label>
				</div>
			)
		} else if (param.type == 'date') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} style={{ display: 'inline-block' }}>
					<div>{param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d" }} value={this.state.date} onChange={date => { date[0] ? this.setState({ date: date[0] }) : this.setState({ date: undefined }) }} />
				</div>
			)
		} else if (param.type == 'boolean') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.name}</div>
					<div className="activeBox" onClick={this.toggle(param.name)}>
						<div className={this.state.editing[param.name] ? "enabled" : "disabled"}></div>
					</div>
				</div>
			)
		} else if (param.type == 'timeOfDay') {
			return (
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{ lineHeight: '57px' }}>{param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ allowInput: true, dateFormat: "h:i K", noCalendar: true, enableTime: true }} value={this.state.editing[param.name]} onChange={this.timeSelect(param.name)} />
					{this.state.editing[param.name] ? <div style={{ lineHeight: '57px', cursor: 'pointer' }} onClick={this.clearDateTime(param.name)}>X</div> : ''}
				</div>
			)
		} else if (param.type == 'series') {
			var series = []
			var stopSeries = false
			for (var subItem of param.series) {
				if (subItem instanceof Array) {
					var grouping = []
					var subStopSeries = true
					for (var subSubItem of subItem) {

						if (!this.state.editing.hasOwnProperty(subSubItem.name) || this.state.editing[subSubItem.name] == '' || this.state.editing[subSubItem.name] == null) {
							if (!stopSeries) { grouping.push(this.renderDynamicInput(subSubItem)) }

						} else {
							subStopSeries = false
							grouping.push(this.renderDynamicInput(subSubItem))
						}

					}
					series.push(<div style={{ display: 'flex' }} key={'groupInput' + subSubItem.name}>{grouping}</div>)
					if (subStopSeries) {
						stopSeries = true
					}
				} else {
					if (!this.state.editing.hasOwnProperty(subItem.name) || this.state.editing[subItem.name] == "" || this.state.editing[subItem.name] == null) {
						if (!stopSeries) { series.push(this.renderDynamicInput(subItem)) }
						stopSeries = true
					} else {
						series.push(this.renderDynamicInput(subItem))
					}
				}
			}
			return (<div key={'seriesInput' + param.name}>{series}</div>)

		} else if (param.type == 'dynamicDropdown') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.name}</div>
					<ReactSuperSelect ajaxDataFetch={() => { return new Promise(async (res, rej) => { var response = await fetch(window.location.origin + '/data?path=' + param.path); if (response.ok) { var ddArray = []; var ddItems = await response.json(); for (var ddItem in ddItems) { ddArray.push({ id: ddItems[ddItem][param.param], name: ddItems[ddItem][param.param] }) }; res(ddArray) }; }) }} initialValue={{ id: this.state.editing[param.name], name: this.state.editing[param.name] }} onChange={this.selectDDDValue(param.name)} />

				</div>
			)
		} else if (param.type == 'dropdown') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.name}</div>
					<ReactSuperSelect dataSource={param.options} initialValue={{ id: this.state.editing[param.name], name: this.state.editing[param.name] }} onChange={this.selectDDDValue(param.name)} />

				</div>
			)
		}
	}


	selectDDDValue = (field) => (valueObject) => {
		console.log(valueObject)
		var newState = this.state.editing
		if (valueObject && valueObject.name) {
			newState[field] = valueObject.name
		} else {
			delete newState[field]
		}
		this.setState({ editing: newState })
	}

	getIdentifier = (item) => {
		var oneLevelDeeper = (subItem) => {
			if (subItem instanceof Array) {
				return oneLevelDeeper(subItem[0])
			} else {
				return subItem.name
			}
		}
		return oneLevelDeeper(this.props.data[this.state.view].schema[0])
	}

	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc = (sortBy, sortOrder) => {
		return function (a, b) {
			if (sortBy === "status" || sortBy === "ActivityDateTime") {
				if ('status' in a && 'status' in b) {
					if (!a.loggedIn && !b.loggedIn) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					} else if (!a.loggedIn) {
						return 1
					} else if (!b.loggedIn) {
						return -1
					}
					if (a[sortBy] === b[sortBy]) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				} else {
					if ('status' in a) {
						return -1
					}
					return 1
				}
			}

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc = (array, filterBy) => {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true;
		})
	}

	render() {
		if (this.props.active) {
			var items = []

			for (var id in this.props.data[this.state.view].data) {
				items.push(this.props.data[this.state.view].data[id]);
			}
			//Filtering items List
			if (Object.keys(this.state.filterBy).length > 0) {
				items = this.filterFunc(items, this.state.filterBy)
			}

			//Sorting filtered User List
			if (this.state.sortBy !== '') {
				items.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}
			var list = []
			var i = 0
			for (var item of items) {
				var fields = []
				for (var displayParam of this.props.data[this.state.view].schema) {
					if (displayParam instanceof Array) {
						for (var subItem of displayParam) {
							if (subItem.display) {
								fields.push(
									<span key={i++} style={{ flex: '1 1 100px' }} >{item[subItem.name]}</span>
								)
							}
						}
					} else {
						if (displayParam.display) {
							fields.push(
								<span key={i++} style={{ flex: '1 1 100px' }} >{item[displayParam.name]}</span>
							)
						}
					}
				}
				list.push(
					<div className="dataRow" key={item.id} onClick={this.props.data[this.state.view].actions.edit ? this.edit(item) : ''} >
						{fields}
						{this.props.data[this.state.view].actions.delete ?
							<span className="buttonBox" style={{ flex: '1 1 100px' }}>
								<img src={this.props.img.delete} alt="Delete Holiday" onClick={this.delete(item)} />
							</span>
							: ''
						}
					</div>
				)
			}
			var headers = []
			var filters = []
			for (var param of this.props.data[this.state.view].schema) {
				if (param instanceof Array) {
					for (var subItem of param) {
						if (subItem.display) {
							headers.push(
								<span key={'header' + subItem.name} style={{ cursor: 'pointer', flex: '1 1 100px' }} onClick={this.sort(subItem.name)} >{subItem.name}</span>
							)
							filters.push(
								<input key={'filter' + subItem.name} style={{ flex: '1 1 100px' }} type="text" onChange={this.filter(subItem.name)} value={this.state.filterBy[subItem.name]} />
							)
						}
					}
				} else {
					if (param.display) {
						headers.push(
							<span key={'header' + param.name} onClick={this.sort(param.name)} style={{ cursor: 'pointer', flex: '1 1 100px' }} >{param.name}</span>
						)
						filters.push(
							<input key={'filter' + param.name} style={{ flex: '1 1 100px' }} type="text" onChange={this.filter(param.name)} value={this.state.filterBy[param.name]} />
						)
					}
				}

			}
			headers.push(
				<span key={'headerButtonBox'} style={{ flex: '1 1 100px' }} ></span>
			)
			filters.push(
				<span key={'headerButtonBox'} style={{ flex: '1 1 100px' }} ></span>
			)


			var editing, deleting
			if (this.state.editing) {
				var editfields = []
				for (var param of this.props.data[this.state.view].schema) {
					editfields.push(this.renderDynamicInput(param))
				}
				editing = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							{editfields}

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
						</div>
					</div>
				)
			}

			if (this.state.deleting) {
				deleting = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are removing</div>
							<div style={{ padding: '25px' }}>{this.getIdentifier(this.props.data[this.state.view].schema[0])}: {this.state.deleting[this.getIdentifier(this.props.data[this.state.view].schema[0])]} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
						</div>
					</div>
				)
			}
			return (
				<div width="100%">
					{this.props.data[this.state.view].actions.add ? <img src={this.props.img.plus} className="plusButton" alt="Add" onClick={this.edit(null)} /> : ''}
					<div className="dataHeaders">
						{headers}
					</div>
					<div className="dataFilters">
						{filters}
					</div>
					<div style={{ color: '#137', padding: '5px 10px', fontWeight: '400', fontSize: '20px' }}>{'Displaying ' + list.length + ' of ' + Object.keys(this.props.data[this.state.view].data).length + ' Records...'}</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{list}

					</div>
					{editing}
					{deleting}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuObject"
export { Dynamic, icon }